/**
 * Manufacturer invoicing Shipments table — column hover hint copy and location id resolution.
 * Keep this file free of UI path aliases so node:test can import it directly.
 */

const MRP_LOCATION_PUBLIC_LOCATION_ID = {
  sgs: 1,
  suntronic: 2,
  kodiak: 14,
} as const;

const MRP_LOCATION_LABELS: ReadonlyArray<{ code: keyof typeof MRP_LOCATION_PUBLIC_LOCATION_ID; label: string }> = [
  { code: "kodiak", label: "Kodiak" },
  { code: "sgs", label: "SGS" },
  { code: "suntronic", label: "Suntronic" },
];

/** Quantity still unmatched on this shipment line. */
export const SUNTRONIC_SHIPMENTS_REMAINING_QTY_HOVER_HINT =
  "Quantity still unmatched on this shipment line. Shipped quantity minus quantity already matched onto manufacturer invoices.";

/** Quantity already matched onto manufacturer invoices for this shipment line. */
export const SUNTRONIC_SHIPMENTS_MATCHED_QTY_HOVER_HINT =
  "Quantity already matched from this shipment line onto manufacturer invoices. Sum of invoice match quantities for this shipment and batch item.";

export function resolveSuntronicShipmentLocationId(
  locationId: number | string | null | undefined,
  locationName: string | null | undefined,
): number | null {
  const numeric = locationId == null || locationId === "" ? Number.NaN : Number(locationId);
  if (Number.isFinite(numeric) && numeric > 0) {
    return numeric;
  }
  const trimmed = (locationName ?? "").trim().toLowerCase();
  if (trimmed === "") return null;
  for (const row of MRP_LOCATION_LABELS) {
    if (row.label.toLowerCase() === trimmed || row.code === trimmed) {
      return MRP_LOCATION_PUBLIC_LOCATION_ID[row.code];
    }
  }
  return null;
}
